// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2OSCK","info":"Note_info__3dteH","note":"Note_note__1Svjc","actions":"Note_actions__3xLQx"};